import { Module, GetterTree, ActionTree, MutationTree } from 'vuex';
import http from '@/http';

const state: ServiceCandidateState = {
  activeServiceCandidate: {},
};

const getters: GetterTree<ServiceCandidateState, RootState> = {};

const actions: ActionTree<ServiceCandidateState, RootState> = {
  fetch({ commit }, oid) {
    return http.v1.scan
      .fetch(oid, {
        params: {
          expand: [
            'booking_candidate.questionnaire_answer',
            'booking_candidate.booking',
            'service_item',
            'service_comment',
            'service_request.business.business_contacts',
            'service_request.business.primary_contact',
          ],
        },
      })
      .then((response) => {
        if (response.data.data) {
          commit('SET_ACTIVE_SERVICE_CANDIDATE', response.data.data);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  },
  fetchList(context, options) {
    return http.v1.scan.fetchList(options).then(({ data }) => {
      const payload = data;
      const items = payload.data.data;
      return {
        items,
        total: payload.data.total,
      };
    });
  },
  pickup({ commit }, oid) {
    return http.v1.scan.pickup(oid).then((response) => {
      if (response.data.data) {
        commit('SET_ACTIVE_SERVICE_CANDIDATE', response.data.data);
      }
    });
  },
  comment(_, serviceCandidate) {
    return http.v1.scan.comment(serviceCandidate.object_id, {
      comment: serviceCandidate.service_comment.comment,
      response_to_business_message:
        serviceCandidate.service_comment.response_to_business_message,
    });
  },
  complete(_, serviceCandidate) {
    return http.v1.scan.complete(serviceCandidate.object_id, {
      signature_image: serviceCandidate.service_comment.signature_image,
    });
  },
  businessMessage(_, serviceCandidate) {
    return http.v1.scan.businessMessage(serviceCandidate.object_id, {
      business_message: serviceCandidate.business_message,
    });
  },
};

const mutations: MutationTree<ServiceCandidateState> = {
  SET_ACTIVE_SERVICE_CANDIDATE(state, activeServiceCandidate) {
    if (!activeServiceCandidate.service_comment) {
      activeServiceCandidate.service_comment = {
        comment: '',
      };
    }
    state.activeServiceCandidate = activeServiceCandidate;
  },
  CLEAR_STATE(state) {
    state.activeServiceCandidate = {};
  },
};

const serviceCandidate: Module<ServiceCandidateState, RootState> = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

export default serviceCandidate;
